import React from 'react';
import ProjectsCoilBackground from './ProjectsCoilBackground';
import ProjectsAlbumCarousel from './ProjectsAlbumCarousel';
import SectionWave from './SectionWave';

const PROJECTS_SECTION_BG = '/bg.avif';

const HomeProjectsSection = ({
  id = 'projets',
  projects,
  eyebrow,
  title,
  titleLine2,
  subtitle,
}) => (
  <section
    className="rihen-section rihen-section--projects projects-section--coil projects-section--with-wave"
    id={id}
  >
    <SectionWave className="section-wave--section-start" />

    <div
      className="projects-section__bg"
      style={{ backgroundImage: `url('${PROJECTS_SECTION_BG}')` }}
      aria-hidden="true"
    />
    <div className="projects-section__scrim" aria-hidden="true" />

    <ProjectsCoilBackground />

    <div className="rihen-site-inner">
      <ProjectsAlbumCarousel
        projects={projects}
        title={title}
        titleLine2={titleLine2}
        subtitle={subtitle}
      />
    </div>
  </section>
);

export default HomeProjectsSection;
